import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';

function RegisterModal({ show, handleClose }) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        // Email format validation
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setMessage('Please enter a valid email address.');
            setLoading(false);
            return;
        }

        // Password complexity validation
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
        if (!passwordRegex.test(password)) {
            setMessage('Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.');
            setLoading(false);
            return;
        }

        // Password confirmation
        if (password !== confirmPassword) {
            setMessage('Password confirmation does not match.');
            setLoading(false);
            return;
        }

        const userData = { name, email, password, password_confirmation: confirmPassword };

        try {
            const response = await axios.post('https://agpipefitting.org.et/api/register', userData);

            if (response.status === 201) {
                setMessage('Registration successful!');
                setName('');
                setEmail('');
                setPassword('');
                setConfirmPassword('');

                handleClose();
                setTimeout(() => {
                    navigate('/login', { replace: true });
                }, 0);
            }
        } catch (error) {
            console.error('Registration Error:', error);
            let errorMessage = 'Registration failed. Please try again.';

            if (error.response?.data?.errors) {
                errorMessage = Object.values(error.response.data.errors).flat().join(' ');
            } else {
                errorMessage = error.response?.data?.message ||
                    error.response?.data?.error ||
                    errorMessage;
            }

            setMessage(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const handleModalClose = () => {
        setName('');
        setEmail('');
        setPassword('');
        setConfirmPassword('');
        setMessage('');
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleModalClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Register</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Password</label>
                        <div className="input-group">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => setShowPassword(!showPassword)}
                                tabIndex={-1}
                            >
                                {showPassword ? "Hide" : "Show"}
                            </button>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Confirm Password</label>
                        <div className="input-group">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                className="form-control"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                tabIndex={-1}
                            >
                                {showConfirmPassword ? "Hide" : "Show"}
                            </button>
                        </div>
                    </div>
                    <Button
                        type="submit"
                        variant="primary"
                        className="w-100"
                        disabled={loading}
                    >
                        {loading ? 'Registering...' : 'Register'}
                    </Button>
                </form>
                {message && (
                    <div className={`mt-3 alert ${message.includes('success') ? 'alert-success' : 'alert-danger'}`}>
                        {message}
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default RegisterModal;
